import { User } from '../model/user';
import { StringHelper } from './string-helper';

export default class UserHelper {
  static translateType(value) {
    switch (value) {
      case 'ATELIER':
        return 'Atelier';
      case 'LOCATION_PLANNING':
        return 'Locatie/Planning';
        break;
      case 'DESIGNER':
        return 'Design';
        break;
      case 'PLACER':
        return 'Projectinstallateur';
        break;
      case 'PRINTER':
        return 'Drukker';
        break;
      case 'FINISHER':
        return 'Afwerking';
        break;
      case 'INVOICING':
        return 'Facturatie';
        break;
      case 'QUOTATION':
        return 'Offerte';
        break;
      case 'EXTERNAL_SUPPLIER':
        return 'Externe leveranciers';
      case 'IP_PLACER':
        return 'IP-installateur';
      case 'ADHESIVE_PLACER':
        return 'Kleefwerk';
      case 'SITE_VISIT':
        return 'Werfbezoek';
      case 'IMMO_ADMIN':
        return 'Immo admin';
      default:
        return 'geen vertaling ingegeven';
        break;
    }
  }

  static getLettres(user: User) {
    let result = '';
    if (user) {
      result = result + (user.firstName == null ? '' : user.firstName[0]);
      result = result + (user.lastName == null ? '' : user.lastName[0]);
    }
    return result;
  }

  static getName(user: User) {
    let result = '';
    if (user) {
      result = result + user.firstName;
      result = result + ' ' + user.lastName;
    }
    return result;
  }

  static getDisplayName(user: User): string {
    if (user == null) {
      return null;
    }
    return StringHelper.join(
      [
        user.firstName == null ? null : user.firstName.toString(),
        user.lastName == null ? null : user.lastName.toString(),
      ],
      ' '
    );
  }

  static isAdmin(user: User) {
    for (let r of user.roles) {
      if (r.name.toString() === 'ROLE_ADMIN') {
        return true;
      }
    }
    return false;
  }

  static isClient(user: User): boolean {
    for (let r of user.roles) {
      if (r.name.toString() === 'ROLE_PORTAL_USER') {
        return true;
      }
    }
    return false;
  }

  static isPlacer(user: User): boolean {
    return (
      user.employee != null &&
      user.employee.types != null &&
      (<string[]>(<unknown>user.employee.types)).includes('PLACER')
    );
  }

  static isIPPlacer(user: User): boolean {
    return (
      user.employee != null &&
      user.employee.types != null &&
      (<string[]>(<unknown>user.employee.types)).includes('IP_PLACER')
    );
  }

  static isAtelier(user: User): boolean {
    return (
      user.employee != null &&
      user.employee.types != null &&
      (<string[]>(<unknown>user.employee.types)).includes('ATELIER')
    );
  }

  static hasRole(user: User, ...roles: string[]): boolean {
    return (
      roles != null &&
      user.roles != null &&
      user.roles.some((r) => roles.includes(r.name.toString()))
    );
  }
}
